import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_DURATIONS, ADD_DURATION, DURATION_ERROR
} from './types';

import { base_url } from './constants';

axios.defaults.baseURL = base_url;

//GET Categories
export const getDurations = () => async dispatch => {
    try {
        const res = await axios.get('/api/durations/');
        dispatch({ type: GET_DURATIONS, payload: res.data })
    } catch (err) {
        dispatch({
            type: DURATION_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}


export const createDuration = formData => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        const res = await axios.post('/api/durations/create', formData, config);
        dispatch({
            type: ADD_DURATION,
            payload: res.data
        });

        dispatch(setAlert('Service Created', 'success'));


    } catch (err) {
        const errors = err.response.data.errors;
        console.log(errors);
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: DURATION_ERROR,
        });
    }
}